import {
    FETCH_BALANCE_REPORTING_REQUEST,
    FETCH_BALANCE_REPORTING_SUCCESS,
    FETCH_BALANCE_REPORTING_FAILURE,
  } from '../actions/transactionReportActions';
  
  const initialState = {
    balanceLogData: [],
    loading: false,
    error: null,
  };
  
  const balanceLogReducer = (state = initialState, action) => {
    //console.log('action>>>>>', action);
    switch (action.type) {
      case FETCH_BALANCE_REPORTING_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FETCH_BALANCE_REPORTING_SUCCESS:
        console.log('action --- >>', action);
        return {
          ...state,
          loading: false,
          balanceLogData: action.payload, // Fix here
          error: null,
        };
      case FETCH_BALANCE_REPORTING_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default balanceLogReducer;